import React from 'react'
import './Logo.scss'

const Logo = ({ size = 'medium' }) => {
  return (
    <div className={`logo logo-${size}`}>
      <div className="logo-circle" aria-label="Paradzai Gwira logo">
        <span>PG</span>
      </div>
    </div>
  )
}

export default Logo

